import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";
import * as Unicons from "@iconscout/react-unicons";

const getEmbedUrl = (url) => {
  if (!url) return "";
  if (url.includes("drive.google.com")) {
    return url
      .replace(/\/view(\?.*)?$/, "/preview")
      .replace(/\/edit(\?.*)?$/, "/preview");
  }
  return url;
};

const WatchDemoButton = ({
  videoUrl,
  buttonText = "Watch Demo",
  className = "py-2 text-md px-7 rounded-md bg-[#fff] inline-flex gap-2 items-center text-[#018081] font-medium h-10 shadow-md hover:bg-gray-100 transition-colors",
  modalTitle = "Demo Video",
  children,
  ...props
}) => {
  const embedUrl = getEmbedUrl(videoUrl);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <button onClick={onOpen} className={className} {...props}>
        {children || (
          <>
            {buttonText} <Unicons.UilPlay />
          </>
        )}
      </button>

      <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
        <ModalOverlay />
        <ModalContent
          bg="black"
          color="white"
          borderRadius="xl"
          overflow="hidden"
        >
          <ModalHeader className="border-b border-gray-800">
            {modalTitle}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0}>
            <div className="aspect-video w-full">
              <iframe
                src={embedUrl}
                title={modalTitle}
                className="w-full h-[500px]"
                allow="autoplay"
                allowFullScreen
              ></iframe>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default WatchDemoButton;
